export default {

  props: {
    sessionProgram: {
      type: Object,
      required: true,
    },

    sortedTargets: {
      type: Array,
      required: true,
    },

    dense: {
      type: Boolean,
      default: false,
    },

    tiny: {
      type: Boolean,
      default: false,
    },

    data: {
      type: Object,
      required: true,
    },

    activePromptLevels: {
      type: Array,
      default: () => ([]),
    },

    workflowStatuses: {
      type: Object,
      default: () => ({}),
    },

    visible: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },

    sessionType: {
      type: String,
      default: null,
    },
    sessionPaused: {
      type: Boolean,
      default: false,
    },
    sessionDurationOffset: {
      type: Date,
      default: null,
    },

    iosAudio: {
      type: Audio,
      default: null,
    },
  },

  emits: ['record', 'record-multiple-data', 'record-program-data'],

  computed: {

  },

  methods: {

    onRecord(sessionProgram, target, data) {
      this.$emit('record', sessionProgram, target, data);
    },

    onRecordMultipleData(sessionProgram, dataArr, target = null) {
      this.$emit('record-multiple-data', sessionProgram, dataArr, target);
    },

    onRecordProgramData(sessionProgram, programData) {
      this.$emit('record-program-data', sessionProgram, programData);
    },

  },
};
